export default "__VITE_ASSET__9d6f3ce9__"